module.exports = __webpack_public_path__ + "static/img/img_max.9c1ea03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/img_max.jpg
// module id = +rU1
// module chunks = 1